export function GetEventCoords(e) {
  let clientX, clientY;
  if (e.type.startsWith('touch')) {
    if (e.type == 'touchend') {
      clientX = e.changedTouches[0].clientX;
      clientY = e.changedTouches[0].clientY;
    } else {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    }
  } else {
    clientX = e.clientX;
    clientY = e.clientY;
  }
  return { clientX, clientY };
}
